import axios from "axios";
import { API_URL } from "./conection";

export const getUsers = async () => {
  try {
    const res = await axios.get(`${API_URL}/users`);
    return res.data;
  } catch (error) {
    console.error("Error en getUsers:", error);
    return [];
  }
};

export const getUserByEmail = async (email) => {
  try {
    const res = await axios.get(`${API_URL}/users/${encodeURIComponent(email)}`);
    return res.data;
  } catch (error) {
    if (error.response?.status === 404) return null;
    console.error("Error en getUserByEmail:", error);
    return null;
  }
};

export const createUser = async (data) => {
  const res = await axios.post(`${API_URL}/users`, data);
  return res.data;
};

export const updateUser = async (email, data) => {
  const res = await axios.put(`${API_URL}/users/${encodeURIComponent(email)}`, data);
  return res.data;
};

export const deleteUser = async (email) => {
  const res = await axios.delete(`${API_URL}/users/${encodeURIComponent(email)}`);
  return res.data;
};
